<template>
  <el-dialog
    :title="'邀请好友「' + name + '」'"
    :visible.sync="dialogVisible"
    custom-class="invite-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closeDialog"
    :append-to-body="true">
      <div class="context">
        <p class="message">您可以通过复制以下链接或者微信扫码的方式发送给同事，邀请他开通主页。</p>
        <div class="link-wrap">
          <input
            type="text"
            :value="url"
            class="copy-link-input"
            disabled=""
            ref="copylink"
            @click="selectLink">
          <button
            class="el-button--primary copy-link-button"
            id="copy_button"
            :data-clipboard-text="text">
            复制链接
          </button>
        </div>
        <div class="img-wrap">
          <qriously :value="url" :size="150" id="invite_qrcode" />
          <p class="sub-message">微信扫一扫<br>邀请同事开通「学术主页」</p>
        </div>
      </div>
  </el-dialog>
</template>
<script>
import Clipboard from 'clipboard'
import qriously from 'vue-qriously/src/components/v-qriously'
export default {
  props: {
    dialogVisible: Boolean,
    url: String,
    name: String
  },
  mounted () {
    this.initClipBoard()
  },
  methods: {
    initClipBoard () {
      const that = this
      var clipboard = new Clipboard('#copy_button')
      clipboard.on('success', function (e) {
        that.$message({
          message: '复制成功',
          type: 'success'
        })
      })
      clipboard.on('error', function (e) {
        that.$message({
          message: '抱歉，您当前的浏览器版本暂不支持点击复制链接功能，请手动选择链接复制至您的粘贴板',
          type: 'warning'
        })

        // 选中待拷贝文本
        that.selectLink()
      })
    },
    selectLink () {
      // 让文本处于选中状态
      const el = this.$refs.copylink
      if (el.select) {
        el.select()
      }
    },
    closeDialog () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    text: function () {
      return `快来试试免费的在线学术展示服务『学术主页』吧，成果自动维护、访客互动实时通知，点击链接马上成为数字化学者 ${this.url}`
    }
  },
  components: {
    qriously
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/Invite/index.vue